// Path: ./src/app/components/MultiSelectDropDown/index.tsx
import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { SelectChangeEvent } from "@mui/material/Select";
import { AutocompleteOption } from "../CustomAutocomplete";
import { Wrapper, CssMultiSelect, Text } from "./styled";
// import { AutocompleteOption } from "../CustomAutocomplete";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

interface Props<T> {
  title?: string;
  FormControlStyle?: React.CSSProperties;
  wrapperStyle?: string;
  selectedValue?: T[];
  // eslint-disable-next-line no-unused-vars
  onSelect?: (value: T[]) => void;
  selectOptions?: AutocompleteOption<T>[];
  textCss?: string;
  dataTestId?: string;
}

/**
 * 1. this is used when filter category in create flyer item page //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) we can select multiple item, we should use the same multiple item select box
 * 2. this is used in upload menu page, select store tag //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) not a good idea. not consistent wth other store tag selection
 * @param param0
 * @returns
 */
export function MultipleSelect<T>({
  title,
  FormControlStyle,
  wrapperStyle,
  selectedValue,
  onSelect,
  selectOptions,
  textCss,
  dataTestId,
}: Props<T>) {
  /**
   * string content is the JSON.stringfy of the input object
   */
  const stringifySelectedValue = selectedValue?.map((v) => {
    return JSON.stringify(v);
  });
  const [personName, setPersonName] = React.useState<string[]>(
    stringifySelectedValue ? stringifySelectedValue : [],
  );

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) below logic is crazy and need to change. basically, replace Menu item
    const selectedValues = event.target.value as string[];
    const parsedSelectedValues = selectedValues.map((v) => {
      const parsedValue = JSON.parse(v) as AutocompleteOption<T>;
      /**
       * 1.this impact menu tag selection.
       * 2. create flyer item page category selection
       */
      return parsedValue;
    }) as T[]; //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) this is all due to the fact that MenuItem value can only accept string. check https://mui.com/material-ui/api/select/ to see why
    setPersonName(selectedValues); //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) here return only value but not label, will check why although it is what we want
    onSelect && onSelect(parsedSelectedValues);
  };

  return (
    <Wrapper wrapperStyle={wrapperStyle} data-testid="multipleselect-test-id">
      {title && <Text textCss={textCss}>{title}</Text>}
      <FormControl sx={{ m: 1, width: 300, ...FormControlStyle }}>
        <CssMultiSelect
          labelId="multiple-name-label"
          id="multiple-name"
          multiple
          value={personName}
          onChange={handleChange}
          MenuProps={MenuProps}
          data-testid={dataTestId}
        >
          {selectOptions?.map((value, key) => (
            <MenuItem
              key={key}
              value={JSON.stringify(value.value)}
              data-testid={`${dataTestId}-option`}
              sx={{
                backgroundColor: "white",
                "& .Mui-selected": {
                  backgroundColor: "red",
                },
                "&:hover .Mui-selected": {
                  backgroundColor: "red",
                },
              }}
            >
              {value.label}
            </MenuItem>
          ))}
        </CssMultiSelect>
      </FormControl>
    </Wrapper>
  );
}
